import { SplitFeatureFlag } from '@/utils/split/splitConfig';

import { useCallback } from 'react';
import { useSplitTreatments } from '@splitsoftware/splitio-react';

type Treatment = {
  treatment: string;
  config: string | null;
};

type EvaluateResult = {
  treatment: string;
  isFeatureFlagEnabled: boolean;
};

type FeatureFlagResult = {
  isReady: boolean;
  isFeatureFlagEnabled: boolean;
  treatment: string;
  config: unknown;
  evaluate: (attributes?: SplitIO.Attributes) => EvaluateResult;
};

export const useSplitFeatureFlag = (
  flag: SplitFeatureFlag,
  attributes?: SplitIO.Attributes,
): FeatureFlagResult => {
  const { treatments, isReady, client } = useSplitTreatments({
    names: [flag],
    attributes,
  });

  const treatment = treatments[flag] as Treatment;
  const isFeatureFlagEnabled = treatment?.treatment === 'on';

  const evaluate = useCallback(
    (dynamicAttributes?: SplitIO.Attributes): EvaluateResult => {
      if (!client) return { treatment: 'off', isFeatureFlagEnabled: false };
      const result = client.getTreatmentWithConfig(flag, dynamicAttributes);
      return {
        treatment: result.treatment,
        isFeatureFlagEnabled: result.treatment === 'on',
      };
    },
    [client, flag],
  );

  return {
    isReady,
    isFeatureFlagEnabled,
    treatment: treatment?.treatment ?? 'off',
    config: treatment?.config ?? null,
    evaluate,
  };
};
